angular.module('qkr').controller('dynamicModalController', ($scope, $uibModalInstance, $sce, confirmMsg, title, confirmButtonName, cancelButtonName, multiMsgArray) => {
    $scope.confirmMsg = confirmMsg;
    $scope.title = title;
    $scope.multiMsgArray = multiMsgArray;
    $scope.confirmButtonName = confirmButtonName;
    $scope.cancelButtonName = cancelButtonName;
    $scope.errors = {};

    $scope.trustAsHTML = function(messageToConvert) {
        return $sce.trustAsHtml(messageToConvert);
    };

    $scope.ok = function() {
        $uibModalInstance.close('ok');
    };

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };
});



// WEBPACK FOOTER //
// ./src/controllers/modal/dynamic.modal.controller.js